import { RouteDtoModelType } from '../../../../store/mst/models';

const hasAssignedDriver = (route: RouteDtoModelType): boolean =>
  !!route.driver?.id && !!route.driver?.name?.trim();

export default hasAssignedDriver;
